















import Vue from 'vue'
import {Component} from "vue-property-decorator";
import Notes from "@/views/money/components/Notes.vue";

@Component({
  components: {Notes}
})
export default class EditLabel extends Vue {

  originalNote = '';
  note = '';

  created() {
    this.originalNote = this.$route.params.tagName;
    this.note = this.$route.params.tagName;
  }
  goBack(){
    this.$router.replace('/labels')
  }
  saveNote(){
    const tags = JSON.parse(localStorage.getItem('tags') || '[]');
    if (tags.includes(this.note)){
      window.alert('当前标签名已存在');
    }else {
      tags.splice(tags.indexOf(this.originalNote), 1, this.note)
      localStorage.setItem('tags', JSON.stringify(tags));
      window.alert('修改成功');
    }
  }
  deleteNote(){
    const tags = JSON.parse(localStorage.getItem('tags') || '[]');
    tags.splice(tags.indexOf(this.originalNote), 1)
    localStorage.setItem('tags', JSON.stringify(tags));
    window.alert('删除成功');
    this.$router.back();
  }
}
